import React, { useEffect, useRef, useState } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { CircularProgress } from "@mui/material";
import { useShowAlert } from "../../../../../context/AlertContext";
import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import InterRegular from "../../../sale/font/Inter_24pt-Regular-normal";
import InterBold from "../../../sale/font/Inter_24pt-Bold-normal";
import { useNetwork } from "../../../../../context/NetworkContext";
import AxiosInstance from "../../../../../utils/AxiosInstance";
import uRLs from "../../../../../utils/baseUtils";
import handleError from "../../../../../constants/handleError";
import { useAuth } from "../../../../../context/AuthProvider";
import { usePermission } from "../../../../../context/PermissionContext";
import CashButton from "../../../sale/cashbtn";
import PayLaterButton from "../../../sale/PaylaterBtn";
import QRCode from "qrcode";
import { formatCurrency } from "@heartinz/finance";
import {FormatedSaleData} from '../../../../../utils/print/GlobelSaleData';
import { DownloadIcon, PrinterIcon, ShowIcon } from "../../../../../constants/Icons";
const InvoiceThumnail7 = ({
  isViewData,
  selectedTheme,
  selectedSize,
  downloadbtn = false,
  payment = false,
}) => {
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const { permission, blockedPermissions, storeSettings, viewOption } =
    usePermission();
  const { isUser,settings } = useAuth();
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState("");
  const [terms, setTerms] = useState([]);
  const [download, setDownload] = useState(false);
  const [print, setPrint] = useState(false);
  const [error, setErrors] = useState({});
  const [isPaySettleModalOpen, setIsPaySettleModalOpen] = useState(false);
  const [isMainModalOpen, setIsMainModalOpen] = useState(true);
  const [data, setData] = useState({});
  const globalData=FormatedSaleData(data);
  const cashRef = useRef();
  const paylaterRef = useRef();

  const formatTrackMode = (salemode) => {
    switch (salemode?.toUpperCase()) {
      case "BILL":
        return "BILL RECIEPT";
      case "INVOICE":
        return "TAX INVOICE";
      default:
        return salemode;
    }
  };
    const formatCurrencyINR = (value) => {    
    const formatted = Math.abs(value).toLocaleString('en-IN', {
    minimumFractionDigits: 0, 
    maximumFractionDigits: 2  
  });   
    return value < 0 ? `-₹${formatted}` : `₹${formatted}`;
  };

  const saleDate = data?.saledate;
  const timezone = data?.saleby?.timezone;

  let saleTime = "--:--";
  if (saleDate) {
    const zoned = DateConverter.convertToTimeZone(saleDate, timezone);
    saleTime = DateConverter.ISOToDisplayFormat(zoned);
  }

  let createdTime = "--:--";
  if (data?.createdAt) {
    const zoned = DateConverter.convertToTimeZone(data.createdAt, timezone);
    createdTime = DateConverter.ISOToDisplayFormat(zoned);
  }

  const handleSaleItems = async (saleId) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`module/sale/${saleId}`);
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return null;
    }
  };

  const loadImageDimensions = (base64Src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () =>
        resolve({ width: img.naturalWidth, height: img.naturalHeight });
      img.onerror = reject;
      img.src = base64Src;
    });
  };

  // new template starts ////// **/////////////////////////////

  const urlToBase64 = async (url) => {
    const res = await fetch(url);
    const blob = await res.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const joinAddress = (...lines) =>
    lines
      .map((l) => l?.trim())
      .filter(Boolean)
      .join(", ");
 const imagePath = settings?.saleProfileData?.image
      ? uRLs?.IMAGE_URL + "profile/" + settings?.saleProfileData?.image
      : "/assets/images/logo-light.png";
      
  //commercial invoice
   const generateInvoice1 = async () => {
     const doc = new jsPDF("p", "mm", "a4");
 
     const pageW = doc.internal.pageSize.getWidth();
     const pageH = doc.internal.pageSize.getHeight();
 
     const PADDING = 5;
     let boxStartY = 10;
const BORDER_COLOR = selectedTheme?.templateTheme?.borderColor || "#000000";   // pure black
 console.log("b",BORDER_COLOR)
const BORDER_WIDTH = 0.1;
     const MARGIN_LEFT = PADDING;
     const MARGIN_RIGHT = pageW - PADDING;
 
     // ===== TITLE =====
     doc.setFont("helvetica", "bold");
     doc.setFontSize(10);
     doc.text("TAX INVOICE", pageW / 2, 8, { align: "center" });
       const hasShipping =
        globalData.saleto?.shippingAddress &&
        (globalData?.saleto?.shippingAddress?.addressline1 ||
        globalData?.saleto?.shippingAddress?.addressline2 );

     // Define column split points 80 145
     const col1 = hasShipping? PADDING + 70 :PADDING + 80;
     const col2 = hasShipping? PADDING + 128 : PADDING + 145; // Slightly adjusted for better spacing
    const col3 = hasShipping? PADDING + 162 : PADDING + 145;
    
     // Initialize Y trackers for each column
     let leftY = boxStartY + 4;
     let centerY = boxStartY + 4;
     let shippingY = boxStartY + 4;
     let rightY = boxStartY + 4;
 
     // ==============================
     // LEFT SECTION (Company)
     // ==============================
     if (imagePath) {
       try {
         
         const base64 = await urlToBase64(imagePath);
         const { width, height } = await loadImageDimensions(base64);
         const maxWidth = 20;
         const maxHeight = 15;
         const ratio = Math.min(maxWidth / width, maxHeight / height);
         const finalWidth = width * ratio;
         const finalHeight = height * ratio;
         // Use leftY as reference
         doc.addImage(
           base64,
           "PNG",
           MARGIN_LEFT + 2,
           leftY - 2,
           finalWidth,
           finalHeight,
         );
       } catch {
         doc.text("LOGO", MARGIN_LEFT + 2, leftY + 5);
       }
     }
 
     const leftX = 24;
     const availableWidth = col1 - (MARGIN_LEFT + leftX) - 2;
     doc.setFontSize(7.2);
     doc.setFont("Inter-Bold", "bold");
     const companyTitleLines = doc.splitTextToSize(
       globalData?.salefrom?.title || "",
       availableWidth,
     );
 
     companyTitleLines.forEach((line) => {
       doc.text(line, MARGIN_LEFT + leftX, leftY);
       leftY += 3.5;
     });
     doc.text(
       `GSTIN ${globalData?.salefrom?.gstnumber || ""}`,
       MARGIN_LEFT + leftX,
       leftY,
     );
 
     const fromAddress = joinAddress(
       globalData?.salefrom?.addressline1,
       globalData?.salefrom?.addressline2,
       globalData?.salefrom?.district,
       globalData?.salefrom?.state,
       globalData?.salefrom?.pincode,
     );
     doc.setFont("Inter-Regular", "normal");
     leftY += 4;
     const fromAddrLines = doc.splitTextToSize(fromAddress, availableWidth); // Wrapped size
     doc.text(fromAddrLines, MARGIN_LEFT + leftX, leftY);
     leftY += fromAddrLines.length * 4;
     leftY -= 1;
     doc.setFont("Inter-Bold", "bold");
     doc.text("Mobile", MARGIN_LEFT + leftX, leftY);
 
     doc.setFont("Inter-Regular", "normal");
     doc.text(
       `${globalData?.salefrom?.phone || ""}`,
       MARGIN_LEFT + leftX + 10,
       leftY,
     );
 
     leftY += 3;
 
     // Email
     doc.setFont("Inter-Bold", "bold");
     doc.text("Email", MARGIN_LEFT + leftX, leftY);
 
     doc.setFont("Inter-Regular", "normal");
     doc.text(
       `${globalData?.salefrom?.email || ""}`,
       MARGIN_LEFT + leftX + 8,
       leftY,
     );
    
     let centerX = col1 + 2;
     let centerValueX = col2 - 2;
     doc.setFont("Inter-Bold", "bold");
     doc.setFontSize(7.5);
     doc.text("Customer Details:", centerX, centerY);
     centerY += 4;
     doc.setFont("Inter-Regular", "normal");
 
     const name = globalData?.saleto?.name || "";
     const nameWidth = col2 - centerX - 2;
     const nameLines = doc.splitTextToSize(name, nameWidth);
     if (name) {
       nameLines.forEach((line) => {
         doc.text(line, centerX, centerY);
         centerY += 3.5;
       });
     }   
     doc.setFont("Inter-Regular", "normal");
     const custAddress = [
       globalData?.saleto?.addressline1,
       globalData?.saleto?.addressline2,
       globalData?.saleto?.district,
       globalData?.saleto?.state,
       globalData?.saleto?.pincode,
     ]
       .filter(Boolean)
       .join(", ");
     const custAddrLines = doc.splitTextToSize(custAddress, 55);
     doc.text(custAddrLines, centerX, centerY);
     centerY += custAddrLines.length * 4;
     centerY -= 1;
     const contactInfo = `Ph: ${globalData?.saleto?.phone || ""} | GSTIN: ${globalData?.saleto?.gstnumber || ""}`;
     if ((globalData?.saleto?.phone || globalData?.saleto?.gstnumber)) {
     doc.text(contactInfo, centerX, centerY);
     }
     if (globalData?.saleto?.email) {
       centerY += 4;
       doc.text(`Email ${globalData?.saleto?.email || ""}`, centerX, centerY);
     }
     if (globalData?.saleto?.state) {
     centerY += 4;
     doc.setFont("Inter-Bold", "bold");
     doc.text("Place of Supply:", centerX, centerY);
     doc.setFont("Inter-Bold", "bold");
     doc.text(globalData?.saleto?.state || "", centerValueX, centerY, {
       align: "right",
     });    
    }
if (hasShipping) {
// ==============================
     // NEW SECTION (Shipping Details)
     // ==============================
     let shipX = col2 + 2;
     const shipWidth = col3 - shipX - 2;
     doc.setFont("Inter-Bold", "bold");
     doc.text("Shipping Details:", shipX, shippingY);
     shippingY += 4;
     doc.setFont("Inter-Regular", "normal");

     // Fetching shipping information from dataset
     const shippingAddress = [     
        globalData?.saleto?.shippingAddress?.addressline1,
    globalData?.saleto?.shippingAddress?.addressline2,
    globalData?.saleto?.shippingAddress?.district,
    globalData?.saleto?.shippingAddress?.state,
    globalData?.saleto?.shippingAddress?.pincode,
     ].filter(Boolean).join(", ");

     const shipAddrLines = doc.splitTextToSize(shippingAddress, shipWidth);
     doc.text(shipAddrLines, shipX, shippingY);
     shippingY += shipAddrLines.length * 3.5;
    }

     let labelX = col3 + 2;
     let valueX = pageW - PADDING - 2; // The rightmost edge
 
     doc.setFont("Inter-Bold", "bold");
     doc.text("Invoice #:", labelX, rightY);
     doc.setFont("Inter-Regular", "normal");
     doc.text(globalData?.saleno || "", valueX, rightY, { align: "right" });
 
     rightY += 4;
     doc.setFont("Inter-Bold", "bold");
     doc.text("Invoice Date:", labelX, rightY);
     doc.setFont("Inter-Regular", "normal");
     doc.text(
       DateConverter.ISOToDisplayFormat(globalData?.saledate).date || "",
       valueX,
       rightY,
       { align: "right" },
     );
 
     rightY += 4;
     doc.setFont("Inter-Bold", "bold");
     doc.text("Invoice Time:", labelX, rightY);
     const invDateTime = DateConverter.ISOToDisplayFormat(
       DateConverter.convertToTimeZone(globalData?.saledate, isUser.timezone),
     ).time;
     doc.setFont("Inter-Regular", "normal");
     doc.text(invDateTime || "", valueX, rightY, { align: "right" });
     const headerBottomY = Math.max(leftY, centerY, rightY,shippingY) + 3;
     const boxHeight = headerBottomY - boxStartY;
     doc.setDrawColor(BORDER_COLOR);
     doc.rect(MARGIN_LEFT, boxStartY, (pageW - 2 * PADDING), boxHeight);
     doc.line(col1, boxStartY, col1, headerBottomY);
     doc.line(col2, boxStartY, col2, headerBottomY);
     if(hasShipping) {
     doc.line(col3, boxStartY, col3, headerBottomY);
     }
 
 
 // Draw the Table
 autoTable(doc, {
     startY: headerBottomY,
       theme: "grid",
       margin: { left: PADDING, right: PADDING, top: PADDING, bottom: PADDING },
       styles: {
         font: "Inter-Regular",
         fontStyle: "normal",
         fontSize: 8,
         cellPadding: { top: 1, bottom: 1, left: 2, right: 2 },
         textColor: "#041121",
         lineColor:BORDER_COLOR,        
         lineWidth: BORDER_WIDTH,
       },
       headStyles: {
         font: "Inter-Bold",
         fillColor: [255, 255, 255],
         textColor: [0, 0, 0],
         fontStyle: "bold",
         lineWidth: BORDER_WIDTH,
         // lineWidth: { top: 0, bottom: 0.5, left: 0.1, right: 0.1 },
       },
       columnStyles: {
         0: { cellWidth: 12 },
         1: { cellWidth: "auto" },
         2: { cellWidth: 20, halign: "right" },
         3: { cellWidth: 20, halign: "right" },
         4: { cellWidth: 15, halign: "right" },
         5: { cellWidth: 25, halign: "right" },
         6: { cellWidth: 25, halign: "right" },
         7: { cellWidth: 20, halign: "right" },
       },
       head: [
         [
           "#",
           "Item",
           "HSN/SAC",
           "Price",
           "Qty",
           "Taxable Value",
           "Tax Amount",
           "Amount",
         ],
       ],
       //   body: globalData.saleitems.flatMap((it, i) =>
       //   Array.from({ length: 3 }).map((_, j) => [
       //     i * 5 + j + 1,
       //     { content: `${it.title}\n${it.description || ""}` },
       //     it.hsnsac,
       //     formatCurrency(CurrencyConverter.toCurrency(it.baseprice || 0, "INR"), "INR", true, true),
       //     it.quantity,
       //     formatCurrency(CurrencyConverter.toCurrency(it.lineTotalBasePrice || 0, "INR"), "INR", true, true),
       //     formatCurrency(CurrencyConverter.toCurrency(it.lineTotalTaxAmount || 0, "INR"), "INR", true, true),
       //     formatCurrency(CurrencyConverter.toCurrency(it.lineGrandTotal || 0, "INR"), "INR", true, true),
       //   ])
       // ),
       body: globalData.saleitems.map((it, i) => [
         i + 1,
        {
          content: it?.note ? `${it.title}\n${it.note}` : it.title,
          styles: { overflow: "linebreak" },
        },

         it.hsnsac,
         `₹${it.baseprice}`,
         `${it.quantity} ${
          (() => {
            const unitCode = it?.isSecondaryUnit
              ? (it?.unitConfig?.secondaryUnitCode ||"")
              : (it?.unitConfig?.primaryUnitCode || "");
            return unitCode||"" ;
          })()
        }`,
         `₹${it.lineTotalBasePrice}`,
         `₹${it.lineTotalTaxAmount}`,
         `₹${it.lineGrandTotal}`,       
       ]),
     didParseCell: function (globalData) {
         globalData.cell.styles.lineColor = BORDER_COLOR;
 
         if (globalData.section === "head") {
           const colId = globalData.column.index;
           if (colId === 0) globalData.cell.styles.halign = "left";
           if ([2, 3, 4, 5, 6, 7].includes(colId))
             globalData.cell.styles.halign = "right";
         }
         if (globalData.section === "body") {
           const isLastRow =
             globalData.row.index === globalData.table.body.length - 1;
           globalData.cell.styles.lineWidth = {
             top: 0,
             bottom: isLastRow ? 0.1 : 0,
             left: 0.1,
             right: 0.1,
           };
         }
       },
          didDrawPage: function (data) {
       if (data.cursor && data.cursor.y) {
             doc.setDrawColor(BORDER_COLOR);
             doc.setLineWidth(0.1);
             doc.line(
                 data.settings.margin.left, 
                 data.cursor.y, 
                 doc.internal.pageSize.width - data.settings.margin.right, 
                 data.cursor.y
             );
         }
     }
       
 });
 
 const footerStartY = doc.lastAutoTable.finalY;
   
     const summaryText = `Total amount (in words):`;
     const amountWords = `${globalData?.amountinwords || ""}`;
     const bankInfo = [
       [
         "Name:",
         storeSettings?.paymentSettings?.bankDetails?.beneficiaryName || "",
       ],
       [
         "Account #:",
         storeSettings?.paymentSettings?.bankDetails?.accountNo || "",
       ],
       ["IFSC:", storeSettings?.paymentSettings?.bankDetails?.ifsc || ""],
       [
         "Branch:",
         storeSettings?.paymentSettings?.bankDetails?.branchName || "",
       ],
     ];
     let summaryY = doc.lastAutoTable.finalY;
     const bankRows = storeSettings?.paymentSettings?.bankDetails
       ? bankInfo.length
       : 0;
 
     const summaryHeight =
       5 + // top gap
       4 + // amount words
       6 + // spacing
       bankRows * 4 + // bank rows
       8 + // UPI
       35; // QR + summary table safety
 
     if (summaryY + summaryHeight > pageH - PADDING) {
       doc.addPage();      
       summaryY = PADDING; // New top position
       boxStartY = summaryY; // <--- ADD THIS LINE: Resets the rectangle anchor
     }
     doc.setFontSize(8);
     doc.setFont("Inter-Bold", "bold");
     let footerY = summaryY + 5;
     doc.text(summaryText, PADDING + 2, footerY);
     footerY += 4;
     doc.setFont("Inter-Regular", "normal");
     doc.text(amountWords, PADDING + 2, footerY);
 
     footerY += 6;
     doc.setFont("Inter-Bold", "bold");
     if (storeSettings?.paymentSettings?.bankDetails) {
       doc.text("Bank Details:", PADDING + 2, footerY);
       doc.setFont("Inter-Regular", "normal");
       footerY += 4;
       bankInfo.forEach(([label, value]) => {
         doc.setFont("Inter-Regular", "normal");
         doc.text(label, PADDING + 2, footerY);
         doc.setFont("Inter-Bold", "bold");
         doc.text(String(value || ""), PADDING + 20, footerY);
         footerY += 4;
         // doc.text(`${label} ${value}`, PADDING + 2, footerY);
       });
     }
     const upiId = storeSettings?.paymentSettings?.upiId || "";
     doc.setFontSize(8);
     footerY += 3;
     if (upiId) {
       doc.text(`UPI ID: ${upiId}`, PADDING + 2, footerY, { align: "left" });
     }
     // 4. QR Code Section (Center)
     const QRSIZE = 30;
     if (upiId && upiId.trim() !== "") {
       const upiUrl = `upi://pay?pa=${upiId}&pn=${encodeURIComponent(storeSettings?.paymentSettings?.bankDetails?.beneficiaryName || "")}&cu=INR`;
       const qrX = pageW / 2 - 10;
       const qrCodeDataUrl = await QRCode.toDataURL(upiUrl, {
         errorCorrectionLevel: "L",
         scale: 4,
         margin: 1,
       });
       doc.addImage(qrCodeDataUrl, "JPEG", qrX, summaryY + 10, QRSIZE, QRSIZE);
     }
 
     // 5. Right Side: Financial Summary (Taxable, Tax, Total)
     const finalSummaryX = hasShipping ? col2 + 2 : col2 - 20; // Align with the right-most vertical line
     let rightSummaryY = summaryY;
 const summaryWidth = pageW - PADDING - finalSummaryX;
 const rowHeight = 6;
   const paidamount = (globalData?.grandtotal || 0) - (globalData?.balanceDue || 0);

 const rows = [
   ["Taxable Amount", `₹${globalData?.totalbaseprice}`],
   ["Total Tax", `₹${globalData?.totaltaxamount}`],
   ["Total", `₹${globalData?.grandtotal}`],
   ["Amount Payable", `₹${globalData?.balanceDue}`],
   ["Amount Paid", `₹${paidamount.toFixed(2)}`],
 ];
 
 const tableHeight = rows.length * rowHeight;
   doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(9);
   let y = rightSummaryY;
  
     rows.forEach((row, i) => {
         const textY = y + rowHeight / 2 + 1.5;     
         if (row[0] === "Amount Paid") {        
             doc.setFont("Inter-Regular", "normal");
                 
              doc.setDrawColor(BORDER_COLOR);
             const centeredText = `${row[0]} : ${row[1]}`;        
           const boxCenterX = finalSummaryX + (summaryWidth / 2);
             doc.text(centeredText, boxCenterX, textY, { align: "center" });        
             doc.setTextColor(0, 0, 0);
 
         } else {     
             if (row[0] === "Amount Payable") {
                 doc.setFont("Inter-Bold", "bold");
             } else {
                 doc.setFont("Inter-Regular", "normal");
                  doc.setDrawColor(BORDER_COLOR);
             }       
          
             doc.text(row[0], finalSummaryX + 2, textY, { align: "left" });  
             doc.text(row[1], finalSummaryX + summaryWidth - 2, textY, { align: "right" });
         }
         if (i !== rows.length - 1) {
             doc.line(finalSummaryX, y + rowHeight, finalSummaryX + summaryWidth, y + rowHeight);
         }
 
         y += rowHeight;
     });
     doc.setFont("Inter-Regular", "normal");
     const qrBottomY = upiId ? (summaryY + 10 + QRSIZE) : summaryY;
 const tableBottomY = y;
 
 const finalFooterY = Math.max(footerY, tableBottomY, qrBottomY) + 5;
  doc.setDrawColor(BORDER_COLOR);
   doc.setTextColor(0,0,0); 
 
 
     doc.rect(PADDING, boxStartY, pageW - PADDING * 2, finalFooterY - boxStartY);
    
     doc.line(finalSummaryX, rightSummaryY, finalSummaryX, finalFooterY);
    
    
 //     // // 6. BOTTOM SECTION: 3 Sections ( Terms)
   
    const rawTerms = terms || "";
    const footerWidth = pageW  * PADDING;
    const termLines = doc.splitTextToSize(rawTerms, footerWidth ); 
    const termsHeight = termLines.length * 3.5 + 10; 
  
    const sigSectionHeight = 30; 
    let currentY = finalFooterY;
 
 
  const isNewPageNeeded =
   currentY + termsHeight + sigSectionHeight > pageH - PADDING;
 if (rawTerms.trim() !== "") {
 // ✅ DRAW MAIN BORDER ONLY TILL CORRECT END
 if (isNewPageNeeded) { 
   // doc.rect(
   //   PADDING,
   //   boxStartY,
   //   pageW - PADDING * 2,
   //   finalFooterY - boxStartY
   // );
   doc.addPage();
   currentY = PADDING;
   const termsStartY = currentY;
 
   doc.rect(
     PADDING,
     termsStartY,
     pageW - PADDING * 2,
     termsHeight
   );
   } else { 
     doc.rect(
       PADDING,
       boxStartY,
       pageW - PADDING * 2,
       (currentY + termsHeight ) - boxStartY
     );
   }
 
   doc.setFont("Inter-Bold", "bold");
   doc.setFontSize(8);
   doc.text("Terms and Conditions:", PADDING + 2, currentY + 5);
   doc.setFont("Inter-Regular", "normal");
   doc.setFontSize(7);
   termLines.forEach((line, i) => {
       doc.text(line, PADDING + 2, currentY + 10 + i * 3.5);
   });
   currentY += termsHeight;
 }
 doc.setDrawColor(...BORDER_COLOR);
 doc.setLineWidth(BORDER_WIDTH);
   // doc.line(PADDING, currentY, pageW - PADDING, currentY);  
   doc.setFontSize(7);
 const totalFinalY = currentY + sigSectionHeight;
 doc.setDrawColor(...BORDER_COLOR);
 doc.setLineWidth(BORDER_WIDTH);
 const x = PADDING;
  y = currentY;
 const w = pageW - PADDING * 2;
 const h = sigSectionHeight - 8;
 doc.line(x, y, x, y + h);
 doc.line(x + w, y, x + w, y + h);
 doc.line(x, y + h, x + w, y + h);
 // doc.rect(PADDING, currentY,pageW - PADDING * 2, sigSectionHeight-8);
 const sigLineY = currentY + sigSectionHeight - 15; 
 doc.line(PADDING + 2, sigLineY, PADDING + 35, sigLineY);
 doc.setFont("Inter-Regular", "normal");
 doc.setFontSize(7);
 doc.text("Receiver's Signature", PADDING + 2, sigLineY + 4);
 doc.setFont("Inter-Bold", "bold");
 doc.setFontSize(7);
 doc.text(`For ${globalData?.salefrom?.title}`, pageW - PADDING - 2, currentY + 5, { align: "right" });
 if (storeSettings?.invoiceSettings?.signature) {
     try {
         const signimg = uRLs.IMAGE_URL + storeSettings.invoiceSettings.signature;
         const base64 = await urlToBase64(signimg);
         const { width, height } = await loadImageDimensions(base64);
        const maxWidth = 25; // Adjusted for smaller box
         const maxHeight = 10;
          const ratio = Math.min(maxWidth / width, maxHeight / height);
         const imgW = width * ratio;
         const imgH = height * ratio;
         doc.addImage(base64, "PNG", pageW - PADDING - imgW , sigLineY - imgH , imgW, imgH);
     } catch (e) {     
         doc.line(pageW - PADDING - 40, sigLineY, pageW - PADDING - 2, sigLineY);
     }
 } else {   
     doc.line(pageW - PADDING - 45, sigLineY, pageW - PADDING - 2, sigLineY);
 }
 doc.text("Authorized Signatory", pageW - PADDING - 2, sigLineY + 4, { align: "right" });
  
 if (storeSettings?.negobillBranding) {
     const brandingY = totalFinalY - 3;
     doc.setFontSize(8);
     const normalText = "Powered By ";
     const boldText = "NegoBill.com";
     const normalWidth = doc.getTextWidth(normalText);
     const boldWidth = doc.getTextWidth(boldText);
     const startX = (pageW - (normalWidth + boldWidth)) / 2;
 
     doc.setFont("Inter-Regular", "normal");
     doc.text(normalText, startX, brandingY);
     doc.setFont("Inter-Bold", "bold");
     doc.text(boldText, startX + normalWidth, brandingY);
 }
    doc.setDrawColor(...BORDER_COLOR);
 doc.setLineWidth(BORDER_WIDTH);
     setDownload(false);
 
     return doc;
   };



  //A4 bill commercial

 const generateBill1 = async () => {
    const doc = new jsPDF("p", "mm", "a4");

    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();

    const PADDING = 5;
    let boxStartY = 10;

    const MARGIN_LEFT = PADDING;
    const MARGIN_RIGHT = pageW - PADDING;

    // ===== TITLE =====
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text("BILL RECEIPT", pageW / 2, 8, { align: "center" });

    // Define column split points
    const col1 = PADDING + 65;
    const col2 = PADDING + 115; // Slightly adjusted for better spacing
    const col3 = PADDING + 160;
    // Initialize Y trackers for each column
    let leftY = boxStartY + 4;
    let centerY = boxStartY + 4;
    let shippingY = boxStartY + 4;
    let rightY = boxStartY + 4;

    // ==============================
    // LEFT SECTION (Company)
    // ==============================
       const imagePath = settings?.saleProfileData?.image
      ? uRLs?.IMAGE_URL + "profile/" + settings?.saleProfileData?.image
      : "/assets/images/logo-light.png";
    if (imagePath) {
      try {
       
        const base64 = await urlToBase64(imagePath);
        const { width, height } = await loadImageDimensions(base64);
        const maxWidth = 20;
        const maxHeight = 15;
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        const finalWidth = width * ratio;
        const finalHeight = height * ratio;
        // Use leftY as reference
        doc.addImage(
          base64,
          "PNG",
          MARGIN_LEFT + 2,
          leftY - 2,
          finalWidth,
          finalHeight,
        );
      } catch {
        doc.text("LOGO", MARGIN_LEFT + 2, leftY + 5);
      }
    }

    const leftX = 30;
    const availableWidth = col1 - (MARGIN_LEFT + leftX) - 2;
    doc.setFontSize(8);
    doc.setFont("Inter-Bold", "bold");
    const companyTitleLines = doc.splitTextToSize(
      globalData?.salefrom?.title || "",
      availableWidth,
    );

    companyTitleLines.forEach((line) => {
      doc.text(line, MARGIN_LEFT + leftX, leftY);
      leftY += 3.5;
    });
  

    const fromAddress = joinAddress(
      globalData?.salefrom?.addressline1,
      globalData?.salefrom?.addressline2,
      globalData?.salefrom?.district,
      globalData?.salefrom?.state,
      globalData?.salefrom?.pincode,
    );
    doc.setFont("Inter-Regular", "normal");
    // leftY += 4;
    const fromAddrLines = doc.splitTextToSize(fromAddress, 50); // Wrapped size
    doc.text(fromAddrLines, MARGIN_LEFT + leftX, leftY);
    leftY += fromAddrLines.length * 4;
    leftY -= 1;
    doc.setFont("Inter-Bold", "bold");
    doc.text("Mobile", MARGIN_LEFT + leftX, leftY);

    doc.setFont("Inter-Regular", "normal");
    doc.text(
      `${globalData?.salefrom?.phone || ""}`,
      MARGIN_LEFT + leftX + 10,
      leftY,
    );

    leftY += 3;

    // Email
    doc.setFont("Inter-Bold", "bold");
    doc.text("Email", MARGIN_LEFT + leftX, leftY);

    doc.setFont("Inter-Regular", "normal");
    doc.text(
      `${globalData?.salefrom?.email || ""}`,
      MARGIN_LEFT + leftX + 8,
      leftY,
    );

    // ==============================
    // CENTER SECTION (Customer)
    // ==============================
    let centerX = col1 + 2;
    let centerValueX = col2 - 2;
    doc.setFont("Inter-Bold", "bold");
    doc.text("Bill To", centerX, centerY);
    centerY += 4;
    doc.setFont("Inter-Regular", "normal");

    const name = globalData?.saleto?.name || "";
    const nameWidth = col2 - centerX - 4;
    const nameLines = doc.splitTextToSize(name, nameWidth);
    if (name) {
      nameLines.forEach((line) => {
        doc.text(line, centerX, centerY);
        centerY += 3.5;
      });
    }
    //  doc.text(globalData?.saleto?.name || "", centerX, centerY);
    //  centerY += 3;
    doc.setFont("Inter-Regular", "normal");
    const custAddress = [
      globalData?.saleto?.addressline1,
      globalData?.saleto?.addressline2,
      globalData?.saleto?.district,
      globalData?.saleto?.state,
      globalData?.saleto?.pincode,
    ]
      .filter(Boolean)
      .join(", ");

    // if (custAddress) {
    //   centerY += 4;
    // } else {
    //   centerY += 2;
    // }

    const custAddrLines = doc.splitTextToSize(custAddress, 55);
    doc.text(custAddrLines, centerX, centerY);
    centerY += custAddrLines.length * 4;
    centerY -= 1;
    const contactInfo = `Ph: ${globalData?.saleto?.phone || ""} `;
    doc.text(contactInfo, centerX, centerY);
    if (globalData?.saleto?.gstnumber) {
      centerY += 4;
      doc.text(`Email ${globalData?.saleto?.email || ""}`, centerX, centerY);
    }
    centerY += 4;
    doc.setFont("Inter-Bold", "bold");
    doc.text("Place of Supply:", centerX, centerY);
    doc.setFont("Inter-Bold", "bold");
    doc.text(globalData?.saleto?.state || "", centerValueX, centerY, {
      align: "right",
    });
    //  centerY += 4;
    //  doc.text("Bill To:", centerX, centerY);

    // ==============================
    // RIGHT SECTION (Invoice Info) - ALIGNED RIGHT
    // ==============================
    let labelX = col2 + 2;
    let valueX = pageW - PADDING - 2; // The rightmost edge

    doc.setFont("Inter-Bold", "bold");
    doc.text("Bill #:", labelX, rightY);
    doc.setFont("Inter-Regular", "normal");
    doc.text(globalData?.saleno || "", valueX, rightY, { align: "right" });

    rightY += 4;
    doc.setFont("Inter-Bold", "bold");
    doc.text("Bill Date:", labelX, rightY);
    doc.setFont("Inter-Regular", "normal");
    doc.text(
      DateConverter.ISOToDisplayFormat(globalData?.saledate).date || "",
      valueX,
      rightY,
      { align: "right" },
    );

    rightY += 4;
    doc.setFont("Inter-Bold", "bold");
    doc.text("Bill Time:", labelX, rightY);
    const invDateTime = DateConverter.ISOToDisplayFormat(
      DateConverter.convertToTimeZone(globalData?.saledate, isUser.timezone),
    ).time;
    doc.setFont("Inter-Regular", "normal");
    doc.text(invDateTime || "", valueX, rightY, { align: "right" });
    const headerBottomY = Math.max(leftY, centerY, rightY) + 3;
    doc.line(col1, boxStartY, col1, headerBottomY);
    doc.line(col2, boxStartY, col2, headerBottomY);
    doc.line(PADDING, headerBottomY, pageW - PADDING, headerBottomY);

    autoTable(doc, {
      startY: headerBottomY,
      theme: "grid",
      margin: { left: PADDING, right: PADDING, top: PADDING, bottom: PADDING },
      styles: {
        font: "Inter-Regular",
        fontStyle: "normal",
        fontSize: 8,
        cellPadding: { top: 1, bottom: 1, left: 2, right: 2 },
        textColor: "#041121",
        lineColor: [200, 200, 200],
        lineWidth: 0.1,
      },
      headStyles: {
        font: "Inter-Bold",
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        lineWidth: { top: 0, bottom: 0.5, left: 0.1, right: 0.1 },
      },
      columnStyles: {
        0: { cellWidth: 12 },
        1: { cellWidth: "auto" },
        2: { cellWidth: 20, halign: "right" },
        3: { cellWidth: 25, halign: "right" },
        4: { cellWidth: 25, halign: "right" },
        5: { cellWidth: 15, halign: "right" },
       
        6: { cellWidth: 20, halign: "right" },
      },
      head: [
        [
          "#",
          "Item",
          "HSN/SAC",
          "Price",
           "MRP",
          "Qty",         
          "Amount",
        ],
      ],      
      body: globalData.saleitems.map((it, i) => [
        i + 1,
        { content: `${it.title}\n${it.note || ""}` },

        it.hsnsac,
        `₹${it.baseprice}`,
         `₹${it.mrp}`,
        it.quantity,
       
        `₹${it.lineGrandTotal}`,       
      ]),
      didParseCell: function (globalData) {
        globalData.cell.styles.lineColor = [200, 200, 200];

        if (globalData.section === "head") {
          const colId = globalData.column.index;
          if (colId === 0) globalData.cell.styles.halign = "left";
          if ([2, 3, 4, 5, 6, 7].includes(colId))
            globalData.cell.styles.halign = "right";

          globalData.cell.styles.lineWidth = {
            top: 0,
            bottom: 0,
            left: 0.1,
            right: 0.1,
          };
        }

        if (globalData.section === "body") {
          const isLastRow =
            globalData.row.index === globalData.table.body.length - 1;
          globalData.cell.styles.lineWidth = {
            top: 0,
            bottom: isLastRow ? 0.5 : 0,
            left: 0.1,
            right: 0.1,
          };
        }
      },

      didDrawCell: function (globalData) {
        const pageW = doc.internal.pageSize.getWidth();
        const pageH = doc.internal.pageSize.getHeight();
        const pageNumber = doc.internal.getCurrentPageInfo().pageNumber;
        // Draw outer box for each page
        doc.setDrawColor(0);
        doc.setLineWidth(0.1);
        doc.rect(
          PADDING,
          boxStartY,
          pageW - PADDING * 2,
          pageH - boxStartY - PADDING,
        );
        if (pageNumber === 1) {
          // first page
          doc.line(PADDING, headerBottomY, pageW - PADDING, headerBottomY);
        } else {
          boxStartY = PADDING;
        }
        if (globalData.section === "head") {
          globalData.doc.setDrawColor(0, 0, 0);
          globalData.doc.setLineWidth(1);
          globalData.doc.line(
            globalData.cell.x,
            globalData.cell.y + globalData.cell.height,
            globalData.cell.x + globalData.cell.width,
            globalData.cell.y + globalData.cell.height,
          );
        }
      },
    });

    doc.setDrawColor(0);
    doc.setLineWidth(0.1);
    // doc.rect(PADDING, boxStartY, pageW - (PADDING * 2), finalTableY - boxStartY);// below table
    const summaryText = `Total amount (in words):`;
    const amountWords = `${globalData?.amountinwords || ""}`;
    const bankInfo = [
      [
        "Name:",
        storeSettings?.paymentSettings?.bankDetails?.beneficiaryName || "",
      ],
      [
        "Account #:",
        storeSettings?.paymentSettings?.bankDetails?.accountNo || "",
      ],
      ["IFSC:", storeSettings?.paymentSettings?.bankDetails?.ifsc || ""],
      [
        "Branch:",
        storeSettings?.paymentSettings?.bankDetails?.branchName || "",
      ],
    ];
    let summaryY = doc.lastAutoTable.finalY;
    const bankRows = storeSettings?.paymentSettings?.bankDetails
      ? bankInfo.length
      : 0;

    const summaryHeight =
      5 + // top gap
      4 + // amount words
      6 + // spacing
      bankRows * 4 + // bank rows
      8 + // UPI
      35; // QR + summary table safety

    if (summaryY + summaryHeight > pageH - PADDING) {
      doc.addPage();
      summaryY = PADDING; // New top position
      boxStartY = summaryY; // <--- ADD THIS LINE: Resets the rectangle anchor
    }
    doc.setFontSize(8);
    doc.setFont("Inter-Bold", "bold");
    let footerY = summaryY + 5;
    doc.text(summaryText, PADDING + 2, footerY);
    footerY += 4;
    doc.setFont("Inter-Regular", "normal");
    doc.text(amountWords, PADDING + 2, footerY);

    footerY += 6;
    doc.setFont("Inter-Bold", "bold");
    if (storeSettings?.paymentSettings?.bankDetails) {
      doc.text("Bank Details:", PADDING + 2, footerY);
      doc.setFont("Inter-Regular", "normal");
      footerY += 4;
      bankInfo.forEach(([label, value]) => {
        doc.setFont("Inter-Regular", "normal");
        doc.text(label, PADDING + 2, footerY);
        doc.setFont("Inter-Bold", "bold");
        doc.text(String(value || ""), PADDING + 20, footerY);
        footerY += 4;
        // doc.text(`${label} ${value}`, PADDING + 2, footerY);
      });
    }
    const upiId = storeSettings?.paymentSettings?.upiId || "";
    doc.setFontSize(8);
    footerY += 3;
    if (upiId) {
      doc.text(`UPI ID: ${upiId}`, PADDING + 2, footerY, { align: "left" });
    }
    // 4. QR Code Section (Center)
    const QRSIZE = 30;
    if (upiId && upiId.trim() !== "") {
      const upiUrl = `upi://pay?pa=${upiId}&pn=${encodeURIComponent(storeSettings?.paymentSettings?.bankDetails?.beneficiaryName || "")}&cu=INR`;
      const qrX = pageW / 2 - 10;
      const qrCodeDataUrl = await QRCode.toDataURL(upiUrl, {
        errorCorrectionLevel: "L",
        scale: 4,
        margin: 1,
      });
      doc.addImage(qrCodeDataUrl, "JPEG", qrX, summaryY + 10, QRSIZE, QRSIZE);
    }

    // 5. Right Side: Financial Summary (Taxable, Tax, Total)
    const finalSummaryX = col2 - 20; // Align with the right-most vertical line
    let rightSummaryY = summaryY;
const summaryWidth = pageW - PADDING - finalSummaryX;
const rowHeight = 6;

const rows = [
  ["Total", `₹${globalData?.grandtotal}`],
  ["Amount Payable", `₹${globalData?.balanceDue}`],
  ["Amount Paid", `₹${globalData?.paidamount}`],
];

const tableHeight = rows.length * rowHeight;
  doc.setFont("Inter-Regular", "normal");
   doc.setFontSize(9);
   // Top line
doc.line(finalSummaryX, rightSummaryY, finalSummaryX + summaryWidth, rightSummaryY);

// Left line
doc.line(finalSummaryX, rightSummaryY, finalSummaryX, rightSummaryY + tableHeight);

// Right line
doc.line(finalSummaryX + summaryWidth, rightSummaryY, finalSummaryX + summaryWidth, rightSummaryY + tableHeight);
  let y = rightSummaryY;
 
    rows.forEach((row, i) => {
        const textY = y + rowHeight / 2 + 1.5;     
        if (row[0] === "Amount Paid") {        
            doc.setFont("Inter-Regular", "normal");
            // doc.setTextColor(40, 167, 69);       
            
            const centeredText = `${row[0]} : ${row[1]}`;        
          const boxCenterX = finalSummaryX + (summaryWidth / 2);
            doc.text(centeredText, boxCenterX, textY, { align: "center" });        
            doc.setTextColor(0, 0, 0);

        } else {     
            if (row[0] === "Amount Payable") {
                doc.setFont("Inter-Bold", "bold");
            } else {
                doc.setFont("Inter-Regular", "normal");
            }        
            doc.setTextColor(0, 0, 0);
            doc.text(row[0], finalSummaryX + 2, textY, { align: "left" });  
            doc.text(row[1], finalSummaryX + summaryWidth - 2, textY, { align: "right" });
        }
        if (i !== rows.length - 1) {
            doc.line(finalSummaryX, y + rowHeight, finalSummaryX + summaryWidth, y + rowHeight);
        }

        y += rowHeight;
    });
    doc.setFont("Inter-Regular", "normal");
    const finalFooterY = Math.max(footerY, doc.lastAutoTable.finalY) + 5;
    doc.setDrawColor(0);
    doc.setTextColor(0,0,0);
    // doc.setLineWidth(0.5);
    doc.rect(PADDING, boxStartY, pageW - PADDING * 2, finalFooterY - boxStartY);
    doc.line(PADDING, summaryY, pageW - PADDING, summaryY);
    doc.line(finalSummaryX, rightSummaryY, finalSummaryX, finalFooterY);

    // // 6. BOTTOM SECTION: 3 Sections (Notes | Terms | Signature)
   const rawTerms = terms || "";
   const footerWidth = pageW  * PADDING;
   const termLines = doc.splitTextToSize(rawTerms, footerWidth ); 
   const termsHeight = termLines.length * 3.5 + 10; 
   const sigSectionHeight = 30; 
   let currentY = finalFooterY;
   if (currentY + termsHeight + sigSectionHeight > pageH - PADDING) {
      doc.addPage();
      currentY = PADDING;
   }
 
  doc.setFont("Inter-Bold", "bold");
  doc.setFontSize(8);
  doc.text("Terms and Conditions:", PADDING + 2, currentY + 5);
  doc.setFont("Inter-Regular", "normal");
  doc.setFontSize(7);
  termLines.forEach((line, i) => {
      doc.text(line, PADDING + 2, currentY + 10 + i * 3.5);
  });
  currentY += termsHeight;
  doc.setLineWidth(0.1);
  doc.line(PADDING, currentY, pageW - PADDING, currentY);  
  doc.setFontSize(7);
const totalFinalY = currentY + sigSectionHeight;
doc.setDrawColor(0);
doc.setLineWidth(0.1);
doc.rect(PADDING, currentY,pageW - PADDING * 2, sigSectionHeight-8);
const sigLineY = currentY + sigSectionHeight - 15; 
doc.line(PADDING + 2, sigLineY, PADDING + 35, sigLineY);
doc.setFont("Inter-Regular", "normal");
doc.setFontSize(7);
doc.text("Receiver's Signature", PADDING + 2, sigLineY + 4);
doc.setFont("Inter-Bold", "bold");
doc.setFontSize(7);
doc.text(`For ${globalData?.salefrom?.title}`, pageW - PADDING - 2, currentY + 5, { align: "right" });
if (storeSettings?.invoiceSettings?.signature) {
    try {
        const signimg = uRLs.IMAGE_URL + storeSettings.invoiceSettings.signature;
        const base64 = await urlToBase64(signimg);
        const { width, height } = await loadImageDimensions(base64);
       const maxWidth = 25; // Adjusted for smaller box
        const maxHeight = 10;
         const ratio = Math.min(maxWidth / width, maxHeight / height);
        const imgW = width * ratio;
        const imgH = height * ratio;
        doc.addImage(base64, "PNG", pageW - PADDING - imgW , sigLineY - imgH , imgW, imgH);
    } catch (e) {     
        doc.line(pageW - PADDING - 40, sigLineY, pageW - PADDING - 2, sigLineY);
    }
} else {   
    doc.line(pageW - PADDING - 45, sigLineY, pageW - PADDING - 2, sigLineY);
}
doc.text("Authorized Signatory", pageW - PADDING - 2, sigLineY + 4, { align: "right" });
if (storeSettings?.negobillBranding) {
    const brandingY = totalFinalY - 3;
    doc.setFontSize(8);
    const normalText = "Powered By ";
    const boldText = "NegoBill.com";
    const normalWidth = doc.getTextWidth(normalText);
    const boldWidth = doc.getTextWidth(boldText);
    const startX = (pageW - (normalWidth + boldWidth)) / 2;

    doc.setFont("Inter-Regular", "normal");
    doc.text(normalText, startX, brandingY);
    doc.setFont("Inter-Bold", "bold");
    doc.text(boldText, startX + normalWidth, brandingY);
}
    doc.setLineWidth(0.5);
    setDownload(false);

    return doc;
  };

  const handleDownload = async (data) => {
    setDownload(true);
    const { salemode, saleno } = data || {};

    let doc;

    if (salemode?.toUpperCase() === "BILL") {
      doc = await generateBill1();
    } else {
      doc = await generateInvoice1();
    }

    const filenamePrefix = formatTrackMode(salemode)?.replace(/\s+/g, "_");
    doc.save(`${filenamePrefix}_${saleno}.pdf`);
  };

  const handlePrint = async (data, overrideSize = null) => {
    setPrint(true);
    try {
      if (!checkNetwork()) return;

      const paperSize = overrideSize || selectedSize;
      const upperMode = data?.salemode?.toUpperCase();
      let doc;

      if (paperSize === "BILL") {
        doc = await generateBill1();
      } else {
        doc = await generateInvoice1();
      }

      const blob = doc.output("blob");
      const blobUrl = URL.createObjectURL(blob);

      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      iframe.src = blobUrl;
      document.body.appendChild(iframe);

      iframe.onload = () => {
        const printWindow = iframe.contentWindow;

        const cleanup = () => {
          // Remove iframe safely
          if (iframe && iframe.parentNode) {
            iframe.parentNode.removeChild(iframe);
          }

          // Remove listeners
          window.removeEventListener("afterprint", cleanup);
          printWindow.matchMedia("(print)").removeListener(handlePrintState);
        };

        const handlePrintState = (mql) => {
          // WHEN PRINT PREVIEW CLOSES (printed OR canceled)
          if (!mql.matches) {
            setTimeout(cleanup, 50); // small delay makes Chrome stable
          }
        };

        // Watch print state
        printWindow.matchMedia("(print)").addListener(handlePrintState);

        // Also catch Chrome's afterprint
        window.addEventListener("afterprint", cleanup);
        setPrint(false);
        setTimeout(() => {
          if (window.bootstrap && window.bootstrap.Dropdown) {
            const dropdownElementList = [].slice.call(
              document.querySelectorAll(".dropdown-toggle")
            );
            dropdownElementList.map(function (dropdownToggleEl) {
              return new window.bootstrap.Dropdown(dropdownToggleEl);
            });
          }
        }, 100);
        // Trigger printing
        setTimeout(() => {
          printWindow.focus();
          printWindow.print();
        }, 300);
      };
    } catch (error) {
      setPrint(false);
      handleError(error, showAlert);
      return false;
    }
    // finally {
    //   setPrint(false);
    // }
  };

  useEffect(() => {
    setData(isViewData);
  }, [isViewData]);

  useEffect(() => {
    jsPDF.API.events.push([
      "addFonts",
      function () {
        this.addFileToVFS("Inter_24pt-Regular-normal.ttf", InterRegular);
        this.addFileToVFS("Inter_24pt-Bold-normal.ttf", InterBold);
        this.addFont(
          "Inter_24pt-Regular-normal.ttf",
          "Inter-Regular",
          "normal"
        );
        this.addFont("Inter_24pt-Bold-normal.ttf", "Inter-Bold", "bold");
      },
    ]);
  }, []);

 
   const formatCurrency2 = (value) => {
     const amount = CurrencyConverter.toCurrency(value, "INR");
     const formatted = Math.abs(amount).toLocaleString('en-IN', {
     minimumFractionDigits: 0, // Don't force .00
     maximumFractionDigits: 2  // Show up to 2 decimals if they exist (like .78)
   }); 
   
     return value < 0 ? `-₹${formatted}` : `₹${formatted}`;
   };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "p") {
        event.preventDefault();
        handlePrint(data);
      }
    };
    const handleAfterPrint = () => {
      setTimeout(() => {
        window.focus();
      }, 100);
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("afterprint", handleAfterPrint);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("afterprint", handleAfterPrint);
    };
  }, [data]);

  useEffect(() => {
    setTerms(storeSettings?.invoiceSettings?.termsAndConditions);
  }, [storeSettings?.invoiceSettings]);
 const grantotal = CurrencyConverter.toCurrency(data?.grandtotal || 0, "INR");
      const paidamount = CurrencyConverter.toCurrency(
        data?.paidamount || 0,
        "INR",
      );
      const balanceDue = grantotal-paidamount 
       useEffect(() => {
          const upi = storeSettings?.paymentSettings?.upiId;
      
          const name = storeSettings?.paymentSettings?.bankDetails?.beneficiaryName;
          if (!upi) return; // skip until upi is available
      
          const upiUrl = `upi://pay?pa=${upi}&pn=${encodeURIComponent(name)}&cu=INR`;
          console.log("ip",upiUrl)
          QRCode.toDataURL(upiUrl)
            .then((url) => {
              setQrCodeDataUrl(url);
            })
            .catch((err) => {
              console.error("QR Code generation failed: ", err);
            });
        }, [storeSettings?.paymentSettings?.upiId, storeSettings?.paymentSettings?.bankDetails?.beneficiaryName]);
          const actualPaidAmount=globalData?.grandtotal  - globalData?.balanceDue;
 const hasShipping= globalData.saleto?.shippingAddress &&
        (globalData?.saleto?.shippingAddress?.addressline1 ||
        globalData?.saleto?.shippingAddress?.addressline2 );
  return (
    <>
      <div className="invoice-scale">
        {globalData.salemode === "INVOICE" ? (
                    <div className="tm_container">
                      <div className="tm_invoice_wrap">
                        <div className="tm_invoice tm_style1 tm_type1">
                          <div className="tm_invoice_in">
                              <div className="text-center fw-bold py-1  border-dark">
                              TAX INVOICE
                            </div>
                    <div className=""style={{ border: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                                                  <div className="row g-0 " style={{ borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                                                    <div className={`col-${hasShipping ? 4 : 5}  d-flex pe-2 pt-1`}  style={{ borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                                                      <div className="ps-2 pe-2">
                                                        {globalData?.salefrom?.image && (  
                                                          <img
                                                          src={
                                                            settings?.saleProfileData?.image
                                                               ? uRLs.IMAGE_URL +
                                                                 "profile/" + settings?.saleProfileData?.image : "/assets/images/logo-light.png"
                                                            }
                                               className="img-rounded logo mb-0"
                                               height="45"
                                               width="100"
                                               style={{ objectFit: "contain" }}
                                             />
                                                        )}
                                                      </div>
                                                      <div className="font-11"style={{ maxWidth: "400px", wordWrap: "break-word" }}>
                                                        <div className="fw-bold font-11">
                                                          {globalData.salefrom?.title}
                                                        </div>
                                                        {globalData?.salefrom?.gstnumber && (
                                                          <div className="font-11">
                                                            <strong>GSTIN{" "}
                                                            {globalData?.salefrom?.gstnumber}
                                                            </strong>
                                                          </div>
                                                        )}
                                                        <div className="font-11">
                                                          {globalData?.salefrom?.addressline1},{" "}
                                                          {globalData?.salefrom?.addressline2},{" "}                                    
                                                          {globalData?.salefrom?.district},{" "}
                                                          {globalData?.salefrom?.state},{" "}
                                                          {globalData?.salefrom?.pincode}
                                                        </div>
                                                        <div className="font-11">
                                                          <strong>Mobile</strong>{" "}
                                                          {globalData?.salefrom?.phone}
                                                        </div>
                                                        <div className="font-11">
                                                          <strong>Email</strong>{" "}
                                                          {globalData?.salefrom?.email}
                                                        </div>
                                                      </div>
                                                    </div>
                    
                                                    <div className={`col-${hasShipping ? 3 : 4} ps-2  pe-2 font-12`}style={{ borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                                                      <div className="fw-bold font-11">
                                                        Customer Details:
                                                      </div>
                                                      <div className="font-11">{globalData.saleto?.name}</div>
                                                      <div className="font-11">
                                                        {globalData.saleto?.addressline1}{" "}
                                                        {globalData.saleto?.addressline2}{" "}
                                                        {globalData.saleto?.district}{" "}
                                                        {globalData.saleto?.state} {" "}
                                                        {globalData.saleto?.pincode}{" "}
                                                      </div>
                                                       {(globalData?.saleto?.state || globalData?.saleto?.gstnumber) &&(
                                                      <div className="font-11">
                                                        Ph:{globalData?.saleto?.phone} |{" "}
                                                        GSTIN:
                                                        {globalData?.saleto?.gstnumber || "-"}
                                                      </div>
                                                       )}
                                                      {globalData?.saleto?.email &&(
                                                       <div className="font-11">
                                                          Email{" "}
                                                          {globalData?.saleto?.email}
                                                        </div>
                                                      )}
                                                        {globalData?.saleto?.state &&(
                                                      <div className="fw-bold  d-flex justify-content-between mb-1 font-11">
                                                        Place of Supply:
                                                        <span>{globalData?.saleto?.state || ""}</span>
                                                      </div>)}
                                                    </div>
                                                      {hasShipping && (
                                                     <div className="col-3 ps-2 pe-2  font-12"style={{ borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                                                      <div className="fw-bold font-11">
                                                        Shipping Details:
                                                      </div>                                                     
                                                      <div className="font-11">
                                                        {globalData.saleto?.shippingAddress?.addressline1}{" "}
                                                        {globalData.saleto?.shippingAddress?.addressline2}{" "}
                                                        {globalData.saleto?.shippingAddress?.district}{" "}
                                                         {globalData?.saleto?.shippingAddress?.country}{" "}
                                                        {globalData.saleto?.shippingAddress?.state} {" "}
                                                        {globalData.saleto?.shippingAddress?.pincode}{" "}
                                                      </div>                                                     
                                                     {globalData?.saleto?.shippingAddress?.phone && (
                                  <div>Phone: +91 {globalData?.saleto?.shippingAddress?.phone}</div>
                                )}
                                {globalData?.saleto?.shippingAddress?.email && (
                                  <div>Email: {globalData?.saleto?.shippingAddress?.email}</div>
                                )}
                                                      
                                                    </div>
                                          )}
                    
                                                    <div className={`col-${hasShipping ? 2 : 3} pe-2 ps-2 font-12`}>
                                                      <div className="d-flex justify-content-between font-11">
                                                        <strong>Invoice #:</strong>
                                                        <span>{globalData?.saleno}</span>
                                                      </div>
                                                      <div className="d-flex justify-content-between font-11">
                                                        <strong>Invoice Date:</strong>
                                                        <span>{saleTime.date}</span>
                                                      </div>
                                                      <div className="d-flex justify-content-between font-11">
                                                        <strong>Invoice Time:</strong>
                                                        <span>{saleTime.time}</span>
                                                      </div>
                                                    </div>
                                                  </div>
                    
                                                  <table
                                                    className="invoice-table "
                                                    width="100%"
                                                    style={{ borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}
                                                  >
                                                    <thead>
                                                      <tr style={{ borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                                                        <th className=" text-center text-black text-bold background_white   font-10 p-0 " style={{ border: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                                                          #
                                                        </th>
                                                        <th className="text-start  text-black text-bold background_white  font-10 p-0 ps-1"style={{ border: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                                                          Item
                                                        </th>
                                                        <th className="text-end  text-black text-bold background_white  font-10 p-0  pe-1" style={{ border: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                                                          HSN/SAC
                                                        </th>
                                                        <th className="text-end  text-black text-bold background_white  font-10 p-0  pe-1" style={{ border: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                                                          Price
                                                        </th>
                                                        <th className="text-end  text-black text-bold background_white  font-10 p-0 ps-1  pe-1" style={{ border: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                                                          Qty
                                                        </th>
                                                        <th className="text-end  text-black text-bold background_white  font-10 p-0  pe-1" style={{ border: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                                                          Taxable Value
                                                        </th>
                                                        <th className="text-end  text-black text-bold background_white  font-10 p-0  pe-1" style={{ border: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                                                          Tax Amount
                                                        </th>
                                                        <th className="text-end text-black text-bold  background_white  font-10 p-0  pe-1" style={{ borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }} >
                                                          Amount
                                                        </th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {globalData?.saleitems?.map((item, index) => (
                                                        <tr key={index} className="font-10">
                                                          <td className="text-center  p-1"style={{ borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                                                            {index + 1}
                                                          </td>
                                                          <td className="text-start  p-1" style={{ borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                                                            {item?.title}
                                                             <div className="font-10">{item?.note}</div> 
                                                          </td>
                                                          <td className="text-end  p-1" style={{ borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                                                            {item?.hsnsac}
                                                          </td>
                                                          <td className="text-end  p-1"style={{ borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                                                            ₹{item?.baseprice}
                                                          </td>
                                                          <td className="text-end  p-1" style={{ borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                                                            {item?.quantity} {
                                                                (() => {
                                                                  const unitCode = item?.isSecondaryUnit
                                                                    ? (item?.unitConfig?.secondaryUnitCode ||"")
                                                                    : (item?.unitConfig?.primaryUnitCode || "");
                                                                  return unitCode||"" ;
                                                                })()
                                                              }
                                                          </td>
                                                          <td className="text-end  p-1" style={{ borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                                                            ₹{item?.lineTotalBasePrice}
                                                          </td>
                                                          <td className="text-end  p-1" style={{ borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                                                            ₹{item?.lineTotalTaxAmount}
                                                          </td>
                                                          <td className="text-end p-1">
                                                            ₹{item?.lineGrandTotal}
                                                          </td>
                                                        </tr>
                                                      ))}
                                                    </tbody>
                                                  </table>
                    
                                                  <div className="row g-0 "style={{ borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                                                    <div className="col-7 "style={{ borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                                                      <div className="p-2  border-dark font-11">
                                                        <strong>Total amount (in words):</strong>
                                                        <br />
                                                        {globalData?.amountinwords}
                                                      </div>
                                                      <div className="row g-0">
                                                        <div className="col-7 p-2 pt-0  border-dark font-11">
                                                          {storeSettings?.paymentSettings
                                                            ?.bankDetails && (
                                                            <>
                                                              <strong>Bank Details:</strong>
                                                              <div className="d-flex font-11">
                                                                <span style={{ width: "80px" }}>
                                                                  Name:
                                                                </span>
                                                                <strong>
                                                                  {
                                                                    storeSettings?.paymentSettings
                                                                      ?.bankDetails?.beneficiaryName
                                                                  }
                                                                </strong>
                                                              </div>
                                                              <div className="d-flex font-11">
                                                                <span style={{ width: "80px" }}>
                                                                  Account #:
                                                                </span>
                                                                <strong>
                                                                  {
                                                                    storeSettings?.paymentSettings
                                                                      ?.bankDetails?.accountNo
                                                                  }
                                                                </strong>
                                                              </div>
                                                              <div className="d-flex font-11">
                                                                <span style={{ width: "80px" }}>
                                                                  IFSC:
                                                                </span>
                                                                <strong>
                                                                  {
                                                                    storeSettings?.paymentSettings
                                                                      ?.bankDetails?.ifsc
                                                                  }
                                                                </strong>
                                                              </div>
                                                              <div className="mt-2 font-11">
                                                                <strong>
                                                                  UPI ID:{" "}
                                                                  {
                                                                    storeSettings?.paymentSettings
                                                                      ?.upiId
                                                                  }
                                                                </strong>
                                                              </div>{" "}
                                                            </>
                                                          )}
                                                        </div>
                                                        {qrCodeDataUrl && (
                                                          <div className="col-5 d-flex align-items-center justify-content-end">
                                                            <img
                                                              src={qrCodeDataUrl}
                                                              alt="QR"
                                                              style={{
                                                                width: "100px",
                                                                height: "100px",
                                                              }}
                                                            />
                                                          </div>
                                                        )}
                                                      </div>
                                                    </div>
                    
                                                    <div className="col-5">
                                                      {[
                                                        {
                                                          label: "Taxable Amount",
                                                          value: globalData?.totalbaseprice,
                                                        },
                                                        {
                                                          label: "Total Tax",
                                                          value: globalData?.totaltaxamount,
                                                        },
                                                        {
                                                          label: "Total",
                                                          value: globalData?.grandtotal,
                                                          
                                                        },
                                                        {
                                                          label: "Amount Payable ",
                                                          value: globalData?.balanceDue,    
                                                          bold: true,                                  
                                                        },
                                                        {
                                                          label: "Amount Paid",
                                                          value: parseFloat(actualPaidAmount || 0).toFixed(2),
                                                          noBorder: true,
                                                          //  bold: true, 
                                                          isGreen: true,
                                                        },
                                                      ].map((row, i) => (
                                                      <div
                                                      key={i}
                                                      className={`d-flex p-0 ps-1 pe-1 font-10 px-2 
                                                        ${row.isGreen ? "justify-content-center" : "justify-content-between"} 
                                                     
                                                        `}
                                                    style={{
                                                      ...(!row.noBorder && {
                                                        borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`
                                                      })
                                                    }}
                                                    >
                                                      <span className={`${row.bold ? "fw-bold" : ""}`}>
                                                        {row.label}  
                                                      {row.isGreen && <span className="mx-1">:</span>}
                                                      </span>
                                                      
                                                      <span className={`${row.bold ? "fw-bold" : ""}`}>
                                                        ₹{row.value}
                                                      </span>
                                                    </div>
                                                  ))}
                                                    </div>
                                                  </div>
                                                  {terms &&(
                                                    <div className="row g-0 ">
                                                      <div className="col-12   p-2" style={{ border: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                                                      <div className="fw-bold font-10 mb-0">
                                                        Terms and Conditions:
                                                      </div>
                                                      <div
                                                        className="font-9 text-muted"
                                                        style={{
                                                          lineHeight: "1.2",
                                                          whiteSpace: "pre-wrap",
                                                        }}
                                                      >
                                                        {terms}
                                                      </div>
                                                    </div>
                                                    </div>
                                                  )}
                                                  <div className="row g-0 "style={{ borderTop: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                                                    <div
                                                      className="col-3 p-2 d-flex flex-column justify-content-end"
                                                     
                                                    >
                                                      <div className="text-left">
                                                        <div className=" "style={{ width: "120px" , borderTop: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }} ></div>
                                                        <div className="font-10 mt-1">
                                                          Receiver's Signature
                                                        </div>
                                                      </div>
                                                    </div>                              
                    
                                                    <div
                                                      className="col-9 p-2 d-flex flex-column justify-content-end text-end"
                                                      
                                                    >
                                                      <div className="fw-bold font-8 mb-1">
                                                        For {globalData?.salefrom?.title}
                                                      </div>
                    
                                                      <div className="p-0 m-2 me-0">
                                                        {storeSettings?.invoiceSettings
                                                          ?.signature ? (
                                                          <img
                                                            src={
                                                              uRLs.IMAGE_URL +
                                                              storeSettings?.invoiceSettings
                                                                ?.signature
                                                            }
                                                            alt="Signature"
                                                            width="120"
                                                            style={{ marginBottom: "-5px" }} // Slight overlap fix if needed
                                                          />
                                                        ) : (
                                                          <>
                                                            <div className="pt-4">
                                                                <hr className="m-1 ms-auto me-0" 
                                                  style={{borderTop:`1px solid ${selectedTheme?.templateTheme?.borderColor}`,maxWidth:"135px"}} />
                                           
                                                            </div>
                                                          </>
                                                        )}
                                                      </div>
                    
                                                      <div className="fw-bold font-10 pt-1">
                                                        Authorized Signatory
                                                      </div>
                                                    </div>                              
                                                  </div>
                                                     
                                                </div>
                                                  {storeSettings?.negobillBranding &&(
                                                <div className="text-center mt-1 font-11">
                                                  Powered By <strong>NegoBill.com</strong>
                                                </div>
                                                  )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : globalData.salemode === "BILL" ? (
                     <div className="tm_container">
                      <div className="tm_invoice_wrap">
                        <div className="tm_invoice tm_style1 tm_type1">
                          <div className="tm_invoice_in">
                     
                           <div className="text-center fw-bold py-1  border-dark">
                              BILL RECEIPT
                            </div>
                      <div className="border border-1px">
                              <div className="row g-0 border-bottom border-dark">
                                <div className="col-5 border-end  border-right-1px border-dark d-flex pe-2">
                                  <div className="ps-2 pe-2 pt-1" >
                                    {globalData?.salefrom?.image && (
                                                 <img
                                                          src={
                                                            settings?.saleProfileData?.image
                                                               ? uRLs.IMAGE_URL +
                                                                 "profile/" + settings?.saleProfileData?.image : "/assets/images/logo-light.png"
                                                            }
                                               className="img-rounded logo mb-0"
                                               height="45"
                                               width="100"
                                               style={{ objectFit: "contain" }}
                                             />
                                    )}
                                  </div>
                                  <div className="font-11"style={{ maxWidth: "400px", wordWrap: "break-word" }}>
                                    <div className="fw-bold font-11">
                                      {globalData.salefrom?.title}
                                    </div>                                   
                                    <div className="font-11">
                                      {globalData?.salefrom?.addressline1},{" "}
                                      {globalData?.salefrom?.addressline2},{" "}                                    
                                      {globalData?.salefrom?.district},{" "}
                                      {globalData?.salefrom?.state},{" "}
                                      {globalData?.salefrom?.pincode}
                                    </div>
                                    <div className="font-11">
                                      <strong>Mobile</strong>{" "}
                                      {globalData?.salefrom?.phone}
                                    </div>
                                    <div className="font-11">
                                      <strong>Email</strong>{" "}
                                      {globalData?.salefrom?.email}
                                    </div>
                                  </div>
                                </div>

                                <div className="col-4 ps-2 pe-2 border-end border-right-1px border-dark font-12">
                                  <div className="fw-bold font-11">
                                    Customer Details:
                                  </div>
                                  <div className="font-11">{globalData?.saleto?.name}</div>
                                  <div className="font-11">
                                    {globalData?.saleto?.addressline1}{" "}
                                    {globalData?.saleto?.addressline2}{" "}
                                    {globalData?.saleto?.district}{" "}
                                    {globalData?.saleto?.state} {" "}
                                    {globalData.saleto?.pincode}{" "}
                                  </div>
                                     {globalData?.saleto?.phone &&(
                                  <div className="font-11">
                                    Ph:{globalData?.saleto?.phone}
                                  </div>
                                     )}
                                  {globalData?.saleto?.email &&(
                                   <div className="font-11">
                                      Email{" "}
                                      {globalData?.saleto?.email}
                                    </div>
                                  )}
                                     {globalData?.saleto?.state &&(
                                  <div className="fw-bold  d-flex justify-content-between mb-1 font-11">
                                    Place of Supply:
                                    <span>{globalData?.saleto?.state || ""}</span>
                                  </div>
                                     )}
                                </div>

                                <div className="col-3 pe-2 ps-2 font-12">
                                  <div className="d-flex justify-content-between font-11">
                                    <strong>Bill #:</strong>
                                    <span>{globalData?.saleno}</span>
                                  </div>
                                  <div className="d-flex justify-content-between font-11">
                                    <strong>Bill Date:</strong>
                                    <span>{saleTime.date}</span>
                                  </div>
                                  <div className="d-flex justify-content-between font-11">
                                    <strong>Bill Time:</strong>
                                    <span>{saleTime.time}</span>
                                  </div>
                                </div>
                              </div>

                              <table
                                className="invoice-table border-bottom border-dark"
                                width="100%"
                              >
                                <thead>
                                  <tr className="border-bottom  ">
                                    <th className=" text-center border-end  border-dark text-black text-bold background_white borderTop-1px border-bottom-1px  font-10 p-0 ">
                                      #
                                    </th>
                                    <th className="text-start border-end  border-dark text-black text-bold background_white borderTop-1px border-bottom-1px font-10 p-0 ps-1">
                                      Item
                                    </th>
                                    <th className="text-end border-end  border-dark text-black text-bold background_white borderTop-1px border-bottom-1px font-10 p-0  pe-1">
                                      HSN/SAC
                                    </th>
                                    <th className="text-end border-end  border-dark text-black text-bold background_white borderTop-1px border-bottom-1px font-10 p-0  pe-1">
                                      Price
                                    </th>
                                    <th className="text-end border-end  border-dark text-black text-bold background_white borderTop-1px border-bottom-1px font-10 p-0  pe-1">
                                      MRP
                                    </th>
                                    <th className="text-end border-end  border-dark text-black text-bold background_white borderTop-1px border-bottom-1px font-10 p-0 ps-1  pe-1">
                                      Qty
                                    </th>
                                   
                                    <th className="text-end text-black text-bold  background_white borderTop-1px border-bottom-1px font-10 p-0  pe-1">
                                      Amount
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {globalData?.saleitems?.map((item, index) => (
                                    <tr key={index} className="font-10">
                                      <td className="text-center border-end  border-dark p-1">
                                        {index + 1}
                                      </td>
                                      <td className="text-start border-end  border-dark p-1">
                                        {item?.title}
                                        {item?.note}
                                      </td>
                                      <td className="text-end border-end  border-dark p-1">
                                        {item?.hsnsac}
                                      </td>
                                      <td className="text-end border-end  border-dark p-1">
                                        ₹{item?.baseprice}
                                      </td>
                                       <td className="text-end border-end  border-dark p-1">
                                        ₹{item?.mrp}
                                      </td>
                                      <td className="text-end border-end  border-dark p-1">
                                        {item?.quantity}
                                      </td>                                     
                                      <td className="text-end p-1">
                                        ₹{item?.lineGrandTotal}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>

                              <div className="row g-0 border-bottom border-dark">
                                <div className="col-7 border-end border-dark">
                                  <div className="p-2  border-dark font-11">
                                    <strong>Total amount (in words):</strong>
                                    <br />
                                    {globalData?.amountinwords}
                                  </div>
                                  <div className="row g-0">
                                    <div className="col-7 p-2 pt-0  border-dark font-11">
                                      {storeSettings?.paymentSettings
                                        ?.bankDetails && (
                                        <>
                                          <strong>Bank Details:</strong>
                                          <div className="d-flex font-11">
                                            <span style={{ width: "80px" }}>
                                              Name:
                                            </span>
                                            <strong>
                                              {
                                                storeSettings?.paymentSettings
                                                  ?.bankDetails?.beneficiaryName
                                              }
                                            </strong>
                                          </div>
                                          <div className="d-flex font-11">
                                            <span style={{ width: "80px" }}>
                                              Account #:
                                            </span>
                                            <strong>
                                              {
                                                storeSettings?.paymentSettings
                                                  ?.bankDetails?.accountNo
                                              }
                                            </strong>
                                          </div>
                                          <div className="d-flex font-11">
                                            <span style={{ width: "80px" }}>
                                              IFSC:
                                            </span>
                                            <strong>
                                              {
                                                storeSettings?.paymentSettings
                                                  ?.bankDetails?.ifsc
                                              }
                                            </strong>
                                          </div>
                                          <div className="mt-2 font-11">
                                            <strong>
                                              UPI ID:{" "}
                                              {
                                                storeSettings?.paymentSettings
                                                  ?.upiId
                                              }
                                            </strong>
                                          </div>{" "}
                                        </>
                                      )}
                                    </div>
                                    {qrCodeDataUrl && (
                                      <div className="col-5 d-flex align-items-center justify-content-end">
                                        <img
                                          src={qrCodeDataUrl}
                                          alt="QR"
                                          style={{
                                            width: "100px",
                                            height: "100px",
                                          }}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-5">
                                  {[
                                    
                                    {
                                      label: "Total",
                                      value: globalData?.grandtotal,
                                      
                                    },
                                    {
                                      label: "Amount Payable ",
                                      value: globalData?.balanceDue,    
                                      bold: true,                                  
                                    },
                                    {
                                      label: "Amount Paid",
                                      value: globalData?.paidamount,
                                      noBorder: true,
                                       bold: true, 
                                      isGreen: true,
                                    },
                                  ].map((row, i) => (
                                  <div
                                  key={i}
                                  className={`d-flex p-0 ps-1 pe-1 font-10 px-2 
                                    ${row.isGreen ? "justify-content-center" : "justify-content-between"} 
                                    ${!row.noBorder ? "border-bottom border-dark" : ""}`}
                                  // style={{
                                  //   color: row.isGreen ? "#28a745" : "black",
                                  // }}
                                >
                                  <span className={`${row.bold ? "fw-bold" : ""}`}>
                                    {row.label}  
                                  {row.isGreen && <span className="mx-1">:</span>}
                                  </span>
                                  
                                  <span className={`${row.bold ? "fw-bold" : ""}`}>
                                    ₹{row.value}
                                  </span>
                                </div>
                              ))}
                                </div>
                              </div>
                              {terms &&(
                                <div className="row g-0 ">
                                  <div className="col-12  border-dark p-2">
                                  <div className="fw-bold font-10 mb-0">
                                    Terms and Conditions:
                                  </div>
                                  <div
                                    className="font-9 text-muted"
                                    style={{
                                      lineHeight: "1.2",
                                      whiteSpace: "pre-wrap",
                                    }}
                                  >
                                    {terms}
                                  </div>
                                </div>
                                </div>
                              )}
                              <div className="row g-0 border-top  border-dark">
                                <div
                                  className="col-3 p-2 d-flex flex-column justify-content-end"
                                 
                                >
                                  <div className="text-left">
                                    <div className="border-top border-dark "style={{ width: "120px" }}></div>
                                    <div className="font-10 mt-1">
                                      Receiver's Signature
                                    </div>
                                  </div>
                                </div>                              

                                <div
                                  className="col-9 p-2 d-flex flex-column justify-content-end text-end"
                                  
                                >
                                  <div className="fw-bold font-8 mb-1">
                                    For {globalData?.salefrom?.title}
                                  </div>

                                  <div className="pe-1">
                                    {storeSettings?.invoiceSettings
                                      ?.signature ? (
                                      <img
                                        src={
                                          uRLs.IMAGE_URL +
                                          storeSettings?.invoiceSettings
                                            ?.signature
                                        }
                                        alt="Signature"
                                        width="120"
                                        style={{ marginBottom: "-5px" }} // Slight overlap fix if needed
                                      />
                                    ) : (
                                      <>
                                        <div className="pt-4">
                                            <hr className="m-1 ms-auto me-0" 
                                                  style={{borderTop:`1px solid ${selectedTheme?.templateTheme?.borderColor}`,maxWidth:"135px"}} />
                                           
                                        </div>
                                      </>
                                    )}
                                  </div>

                                  <div className="fw-bold font-10 pt-1">
                                    Authorized Signatory
                                  </div>
                                </div>                              
                              </div>
                                 
                            </div>
                              {storeSettings?.negobillBranding &&(
                            <div className="text-center mt-1 font-11">
                              Powered By <strong>NegoBill.com</strong>
                            </div>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
          <div className="default-content">
            <p>No content available for this sale mode.</p>
          </div>
        )}
      </div>

      <div
        className="modal-footer d-block mt-2"
        style={{
          position: "sticky",
          bottom: -4,
          background: "#fff",
          zIndex: 10,
          borderTop: "1px solid #e0e0e0",
        }}
      >
        {payment && <div className="fw-600 mb-2 font-14">PAYMENT SUMMARY</div>}
        {payment && (
          <table
            className="items table-bordered mb-3"
            width="100%"
            cellPadding="4"
          >
            <tbody className="text-center">
              <tr>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    cursor: isViewData.cashamount > 0 ? "pointer" : "default",
                    padding: "2px 8px",
                  }}
                  onClick={(e) => {
                    if (isViewData.cashamount > 0) {
                      cashRef.current.openPopover(e);
                    }
                  }}
                >
                  <div
                    className={
                      isViewData?.cashamount > 0
                        ? "badge rounded-pill bg-label-moon d-inline-flex align-items-center"
                        : "d-inline-flex align-items-center"
                    }
                    style={{ gap: "4px", fontSize: "12px" }}
                  >
                    CASH
                    {isViewData?.cashamount > 0 && <ShowIcon/>}
                  </div>
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                >
                  CARD
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                >
                  ONLINE
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                >
                  UPI
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    cursor:
                      isViewData?.paylateramount > 0 ? "pointer" : "default",
                    padding: "2px 8px",
                    fontSize: "12px",
                  }}
                  onClick={(e) => {
                    if (isViewData?.paylateramount > 0) {
                      paylaterRef.current.openPopover(e);
                    }
                  }}
                >
                  <div
                    className={
                      isViewData?.paylateramount > 0
                        ? "badge rounded-pill bg-label-fire d-inline-flex align-items-center"
                        : "d-inline-flex align-items-center"
                    }
                    style={{ gap: "4px" }}
                  >
                    PAYLATER
                    {isViewData?.paylateramount > 0 && (
                      <ShowIcon iClass={"ms-1"}/>
                    )}
                  </div>
                </th>
              </tr>
              <tr>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.cashamount || 0) -
                      (isViewData?.cashchange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.cardamount || 0) -
                      (isViewData?.cardchange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.onlineamount || 0) -
                      (isViewData?.onlinechange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.upiamount || 0) - (isViewData?.upichange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.paylateramount || 0) -
                      (isViewData?.paylaterchange || 0)
                  )}
                </td>
              </tr>
            </tbody>
            <CashButton
              ref={cashRef}
              trackId={isViewData?.boxCashInfo?.trackid}
              trackMode={isViewData?.boxCashInfo?.trackmode}
            />
            <PayLaterButton
              ref={paylaterRef}
              trackId={isViewData?.paylaterInfo?.trackid}
              customerId={isViewData?.paylaterInfo?.customerid}
              trackMode={isViewData?.paylaterInfo?.trackmode}
            />
          </table>
        )}
        {downloadbtn && (
          <div className="my-2 d-flex gap-2">
            <div className="btn-group text-right align-items-center">
              {print ? (
                <button
                  className="btn bg-label-animal btn-sm pb-0 font-12"
                  disabled
                >
                  <CircularProgress size={12} className="text-white" />
                </button>
              ) : (
                <>
                  <button
                    onClick={() => handlePrint(data)}
                    className="btn bg-label-animal shadow-none btn-sm font-12"
                    id="printreceiptbtn"
                  >
                    <PrinterIcon iClass={"fs-12"}/> Print
                  </button>
                </>
              )}
            </div>

            {download ? (
              <button
                className="btn btn-warning btn-sm pb-0 text-right"
                disabled
              >
                <CircularProgress size={18} className="text-black" />
              </button>
            ) : (
              <button
                className="btn btn-warning btn-sm text-right"
                id="generatebillpdfbtn"
                onClick={() => handleDownload(data)}
              >
                <DownloadIcon iClass={"fs-15"}/>
              </button>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default InvoiceThumnail7;
